<template>
  <section class="cta-section">
    <div
      class="card"
      :style="{
        backgroundImage: `url(${getCDNlink(
          'assets/new-assets/Transform-Card-BG.webp'
        )})`,
      }"
    >
      <div class="cta-container">
        <h2 class="cta-title">Start Your Journey</h2>
        <p class="cta-subtitle">
          Get started today to experience <br />how Credence transforms your
          trade finance decisions.
        </p>
        <div class="cta-buttons">
          <button
            class="cta-button primary"
            @click="this.$router.push('/login?type=SignUp')"
          >
            Get Started
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="button-icon"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
          <button
            class="cta-button secondary"
            @click="this.$router.push('/contact')"
          >
            Book A Demo
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config";

export default {
  name: "CallToAction",
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>

<style scoped>
.card {
  align-self: stretch;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px;
  gap: 30px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}

.cta-section {
  width: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 160px 80px 160px;
  box-sizing: border-box;
  text-align: center;
  font-size: 48px;
  color: #fff;
  font-family: Figtree;
}

/* Light glow effect at the top */
.cta-section::before {
  content: "";
  position: absolute;
  top: -50%;
  left: 0;
  right: 0;
  height: 60%;
  background: radial-gradient(
    ellipse at center,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}

.cta-container {
  max-width: -webkit-fill-available;
  margin: 0;
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-title {
  color: #ffffff;
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
  line-height: 1.2;
}

.cta-subtitle {
  color: #ffffff;
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0 auto 2.5rem;
  max-width: 800px;
  font-weight: 600;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 173px;
}

.cta-button.primary {
  background-color: #C94374;
  color: #ffffff;
}

.cta-button.primary:hover {
  background-color: #e43a7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(253, 76, 140, 0.3);
}

.cta-button.secondary {
  background-color: #046BE1;
  color: #ffffff;
}

.cta-button.secondary:hover {
  background-color: #0160d0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(1, 114, 244, 0.3);
}

.button-icon {
  margin-left: 0.5rem;
}

/* Responsive styles */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .cta-title {
    font-size: 2.5rem;
  }

  .cta-subtitle {
    font-size: 1.125rem;
  }
}

@media (max-width: 767px) {
  .cta-section {
    padding: 45px 40px;
  }

  .cta-title {
    font-size: 2rem;
  }

  .cta-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .cta-section {
    padding: 25px;
    border-radius: 0.75rem;
  }

  .card {
    padding: 32px 10px;
  }

  .cta-title {
    font-size: 30px;
    margin-bottom: 1rem;
  }

  .cta-subtitle {
    font-size: 16px;
    margin-bottom: 1.75rem;
    line-height: 1.3;
  }

  .cta-button {
    padding: 0.75rem 1.5rem;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
